<template>
  <input ref="btn" class="pull-right" :class="[classObject, !$store.state.isHkom ? 'text-primary' : 'text-primary--green']" :value="$t('vuePlUpload.defaultText')" type="button" />
</template>

<script>
var plupload = require("plupload");
var _ = require('lodash');

var uploaderDefaultOption = {
  runtimes: 'html5,html4',
  url: '/UploadServlet',
  max_file_size: '10gb',
  chunk_size: '10mb',
  unique_names: false,
  uploadchecksum: false,
  dragdrop: false,
};

export default {
  name: "VuePlupload",
  props: {
    classObject: {
      type: Object,
      default: "plupload-btn"
    },
    browseButton: {
      type: String,
      required: false,
    },
    dropElement: {
      type: String,
      required: false,
    },
    options: {
      type: Object,
      default () {
        return {
          url: "/UploadServlet",
          dragdrop: false,
          filters: {
            max_file_size: '10gb',
            mime_types: [{
              title: "Large files",
              extensions: "*"
            }]
          },
        }
      }
    }
  },

  data() {
    return {
      uploader: null
    }
  },

  watch : {
    "options" : {
      handler (val, oldVal) {
        var self = this;

        if (!self.uploader) {
          self.renderPlupload();
        } else {
          var opt = self.mergeOptions(val);
          self.uploader.setOption(opt);
        }
      },
      deep: true
    }
  },

  methods: {
    mergeOptions(val) {
      if (!this.browseButton) {
        this.browseButton = this.$refs.btn
      }
      var self = this;
      let add_options = {
        browse_button: self.browseButton
      }
      if (this.dropElement) {
        add_options['drop_element'] = this.dropElement
      } else {
        delete uploaderDefaultOption['drop_element']
      }
      return _.merge(uploaderDefaultOption, val, add_options);
    },
    renderPlupload() {
      var self = this;

      var opt = self.mergeOptions(self.options);

      self.uploader = new plupload.Uploader(opt);
      window.uploader = self.uploader
      let arr_files = []

      self.uploader.bind("PostInit", function(uploader){
        if (window.files) {
          var file, i, files = [], id, fileNames = {};

          // Add the selected files to the file queue
          for (i = 0; i < window.files.length; i++) {
            file = window.files[i];
            arr_files.push(file)
            // Safari on Windows will add first file from dragged set multiple times
            // @see: https://bugs.webkit.org/show_bug.cgi?id=37957
            if (fileNames[file.name]) {
              continue;
            }
            fileNames[file.name] = true;

            // Expose id, name and size
            let plFile = new plupload.File(file);
            files.push(plFile);
          }
          window.uploader.addFile(arr_files)
          delete window.files
        }
        self.$emit("init", uploader);
      });

      self.uploader.bind("BeforeUpload", function(up, file){
          self.$emit("before", up, file);
      });

      self.uploader.bind("FilesAdded", function(up, files){
          self.$emit("added", up, files);
      });

      self.uploader.bind("UploadProgress", function(up, file){
          self.$emit("progress", up, file);
      });

      self.uploader.bind("FileUploaded", function(up, file, result){
          self.$emit("uploaded", up, file, result);
      });

      self.uploader.bind("Error", function(up, err){
          self.$emit("error", up, err);
      });

      self.uploader.init();
    }
  },

  mounted() {
    this.renderPlupload();
  }
}
</script>

<style lang="scss">
.plupload-btn {
    background-color: #fff;
    display: inline-block;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.42857143;
    text-align: center;
    vertical-align: middle;
    touch-action: manipulation;
    cursor: pointer;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>




// WEBPACK FOOTER //
// src/components/ui/VuePlupload.vue